import React from 'react';
import './App.css';
import Navbar from './components/Nav';
import Content from './components/Content';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Navbar />
      <Content />
      <Footer />
    </>
  );
}

export default App;
